import React from 'react'

const Animation = () => {
  return (
    <div className="Animation">
      <div className="blur" style={{ top: "-50%", left: "-8rem" }}></div>
    <div className="blur2" style={{ top: "-50%", left: "-8rem" }}></div>
    <div className="blur3" style={{ top: "-50%", left: "-8rem" }}></div>
  </div>
  )
}

export default Animation